// The name an element's rules are filed under.
//
// A class keyed by a hash of the rules themselves is what makes two identical elements share one rule
// instead of two, and what makes the same styles produce the same class on every render, in every tab and
// in the builder's iframe alike. Nothing here reads a counter or a clock: the same text always hashes to
// the same name, or the preview would repaint every element on every keystroke.
//
// Two independent FNV-1a passes are folded together, so a class name carries 64 bits. A shop would need
// hundreds of millions of distinct rules before a collision were worth a thought, and the registry keeps
// the first rule filed under a name in any case.

const FNV_PRIME = 0x01000193;
const FNV_OFFSET = 0x811c9dc5;
const FNV_SECOND_OFFSET = 0x7fffffff;

// Folds one pass of FNV-1a over the text from one starting basis, as an unsigned 32-bit number.
function fnv1a(text: string, basis: number): number {
  let hash = basis >>> 0;
  for (let index = 0; index < text.length; index += 1) {
    hash ^= text.charCodeAt(index);
    hash = Math.imul(hash, FNV_PRIME) >>> 0;
  }
  return hash >>> 0;
}

// Hashes a rule's text into the short, stable name its class wears, so identical elements share one rule.
export function hashStyleText(text: string): string {
  return `${fnv1a(text, FNV_OFFSET).toString(36)}${fnv1a(text, FNV_SECOND_OFFSET).toString(36)}`;
}
